module.exports = __webpack_public_path__ + "img/nature-32.9eef293b.jpg";